import { createSelector } from 'reselect'

import { reduxNamespaceKey } from './actionReducers'

const stateSelector = (state) => state.reportReducer[reduxNamespaceKey]

export const loadingFilterData = createSelector(
  stateSelector,
  (state) => state.loadingFilterData
)
export const filterData = createSelector(
  stateSelector,
  (state) => state.filterData
)
export const profileFilterDataReady = createSelector(
  stateSelector,
  (state) => state.profileFilterDataReady
)

export const loadingClassProfile = createSelector(
  stateSelector,
  (state) => state.loadingClassProfile
)
export const classProfileData = createSelector(
  stateSelector,
  (state) => state.classProfileData
)
export const classProfileError = createSelector(
  stateSelector,
  (state) => state.classProfileError
)

export const loadingStudentProfile = createSelector(
  stateSelector,
  (state) => state.loadingStudentProfile
)
export const studentProfileData = createSelector(
  stateSelector,
  (state) => state.studentProfileData
)
export const studentProfileError = createSelector(
  stateSelector,
  (state) => state.studentProfileError
)

export const loadingClassEnrollment = createSelector(
  stateSelector,
  (state) => state.loadingClassEnrollment
)
export const classDetails = createSelector(
  stateSelector,
  (state) => state.classDetails
)
export const classStudents = createSelector(
  stateSelector,
  (state) => state.classStudents
)
